import { ArrowUpRight, Instagram, Linkedin, Twitter } from "lucide-react";

const cols = [
  {
    title: "Services",
    links: ["SEO", "Paid Ads", "Social", "Content", "Branding", "Analytics"],
  },
  {
    title: "Studio",
    links: ["About", "Process", "Careers", "Contact"],
  },
  {
    title: "Elsewhere",
    links: ["Instagram", "LinkedIn", "Twitter / X", "Dribbble"],
  },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="bg-[#09090b] text-white pt-24 md:pt-32 overflow-hidden"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16 border-b border-zinc-800">
          <div className="md:col-span-5">
            <div className="text-[10px] font-mono uppercase tracking-widest text-zinc-500 mb-4">
              [ START A PROJECT ]
            </div>
            <a
              href="mailto:hello@slideventures.com"
              data-testid="footer-email"
              className="group inline-flex items-center gap-3 font-display font-black uppercase text-3xl md:text-4xl tracking-tight hover:text-[#002FA7] transition-colors"
            >
              hello@slideventures.com
              <ArrowUpRight className="w-8 h-8 transition-transform group-hover:-translate-y-1 group-hover:translate-x-1" />
            </a>
            <div className="mt-8 flex items-center gap-4">
              {[
                { Icon: Instagram, label: "instagram" },
                { Icon: Linkedin, label: "linkedin" },
                { Icon: Twitter, label: "twitter" },
              ].map(({ Icon, label }) => (
                <a
                  key={label}
                  href={`#${label}`}
                  data-testid={`footer-social-${label}`}
                  aria-label={label}
                  className="w-10 h-10 border border-zinc-700 flex items-center justify-center hover:bg-[#002FA7] hover:border-[#002FA7] transition-colors"
                >
                  <Icon className="w-4 h-4" strokeWidth={1.5} />
                </a>
              ))}
            </div>
          </div>

          {cols.map((c) => (
            <div key={c.title} className="md:col-span-2">
              <div className="text-[10px] font-mono uppercase tracking-widest text-zinc-500 mb-4">
                {c.title}
              </div>
              <ul className="space-y-2">
                {c.links.map((l) => (
                  <li key={l}>
                    <a
                      href="#contact"
                      className="text-sm font-medium hover:text-[#002FA7] transition-colors"
                      data-testid={`footer-link-${l.toLowerCase().replace(/\s|\//g, "-")}`}
                    >
                      {l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-1" />
        </div>

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 py-8 text-xs font-mono uppercase tracking-widest text-zinc-500">
          <div>© {year} SLIDE VENTURES — ALL RIGHTS RESERVED</div>
          <div className="flex gap-6">
            <a href="#top" className="hover:text-white transition-colors">
              Privacy
            </a>
            <a href="#top" className="hover:text-white transition-colors">
              Terms
            </a>
            <a href="#top" data-testid="footer-back-to-top" className="hover:text-white transition-colors">
              Back to top ↑
            </a>
          </div>
        </div>
      </div>

      {/* Massive wordmark */}
      <div
        aria-hidden="true"
        className="pt-4 pb-8 leading-none select-none overflow-hidden"
      >
        <div className="font-display font-black uppercase tracking-tighter text-white text-[26vw] leading-[0.85] whitespace-nowrap text-center">
          SLIDE<span className="text-[#002FA7]">.</span>
        </div>
      </div>
    </footer>
  );
}
